
export default {
  name: 'icon-transfer',
};
